var exports = {
  "Qs": "DomainMovedStepsModal.module__content___U0k5WV",
  "Ci": "DomainMovedStepsModal.module__steps___U0k5WV",
  "PM": "DomainMovedStepsModal.module__step___U0k5WV",
};

module.exports = exports;
